import React from 'react';

function DemoScripts() {
  return (
    <div>
        Welcome to DemoScripts Component.
    </div>
  );
}

export default DemoScripts;
